import { DistrictHelpers } from './shared/services/district/district-helpers.service';
import { GraphQLExperiencesHelperService } from './shared/services/graphql-helpers/experiences/experiences-queries.service';
import { StudentSet } from './shared/services/student-set/student-set.service';
import { CourseDiffsAndGapPlansContainerModule } from './school/sdc/course-diffs-and-gap-plans/course-diffs-and-gap-plans-container.module';
import { ToggleService } from 'Src/ng2/shared/services/toggle/toggle.service';
import { UserAndRouteContextService } from 'Src/ng2/shared/services/user-and-route-context/user-and-route-context.service';
import { GraphQLClusterHelperService } from './shared/services/graphql-helpers/clusters/cluster-queries.service';
import { GraphQLPartnerHelperService } from './shared/services/graphql-helpers/partners/partner-queries.service';
import { GraphQLSchoolUserHelperService } from './shared/services/graphql-helpers/user-management/school-user/school-user-queries.service';
import { GraphQlShelterClusterUserHelperService } from './shared/services/graphql-helpers/user-management/cluster-user/shelter-cluster-user-queries.service';
import { GraphQLSchoolClusterUserHelperService } from './shared/services/graphql-helpers/user-management/cluster-user/school-cluster-user-queries.service';
import { GraphQLStudentAssessmentsHelperService } from './shared/services/graphql-helpers/student-assessments/student-assessments-queries.service';
import { GraphQLSchoolAssessmentsHelperService } from './shared/services/graphql-helpers/school-assessments/school-assessments-queries.service';
import { GraphQLActivitiesHelperService } from './shared/services/graphql-helpers/activities/activities-queries.service';
import { GraphQLDataLoadsHelperService } from './shared/services/graphql-helpers/data-loads/data-loads-queries.service';
import { PortalConfig } from './shared/services/portal-config';
import { WindowRef } from 'projects/shared/services/window-ref/windowRef';
import { LocalStorageService } from 'Src/ng2/shared/services/web-storage/local-storage/local-storage.service';
import { DateHelpers } from 'projects/shared/services/date-helpers/date-helpers.service';
import { UtilitiesService } from 'Src/ng2/shared/services/utilities/utilities.service';
import { BooleanYesNoFilter } from './shared/services/boolean-yes-no-filter/boolean-yes-no-filter.service';
import { AgGridFilterService } from './shared/services/ag-grid-filter/ag-grid-filter.service';
import { rollbarFactory, RollbarService } from './shared/services/rollbar/rollbar.service';
import { SorterColumn } from './shared/services/sorter-column/sorter-column.service';
import { DefaultSdcConfigService } from './../app/sdc/sdc-state/sdc-configs/default-sdc-config.service';
import { RegentsPlanningConfigService } from './../app/sdc/sdc-state/sdc-configs/regents-planning-config.service';
import { RegentsPrepConfigService } from './../app/sdc/sdc-state/sdc-configs/regents-prep-config.service';
import { CreditGapsConfigService } from './../app/sdc/sdc-state/sdc-configs/credit-gaps-config.service';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleModule } from '@ng-idle/core';
import { EffectsModule } from '@ngrx/effects';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { GradPlanningConfigService } from 'Src/app/sdc/sdc-state/sdc-configs/grad-planning-config.service';
import { NvToastModule } from './../nvps-libraries/design/nv-toast/nv-toast.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './routing/app-routing.module';
import { GridConfigService } from './school/grid/services/grid-config.service';
import { GridService } from './school/grid/services/grid.service';
import { Auth } from './shared/auth/auth.service';
import { NotificationsModule } from './shared/components/notifications/notifications.module';
import { SpinnerModalModule } from './shared/components/spinner/spinner-modal.module';
import { AssignSupportModalService } from './shared/modals/assign-support/assign-support-modal.service';
import { ErrorModalModule } from './shared/modals/error/error-modal.module';
import { ModalsService } from './shared/modals/modals.service';
import { HttpInterceptorModule } from './shared/services/auth/http-interceptor.module';
import { BackgroundJob } from './shared/services/background-job/background-job.service';
import { CustomErrorHandlerService } from './shared/services/custom-error-handler/custom-error-handler.service';
import { EventBus } from './shared/services/event-bus/event-bus';
import { NvPusherSocketIdInterceptor } from './shared/services/pusher/nv-pusher-interceptor.module';
import { SnackBarService } from './shared/services/snackbar/snackbar.service';
import { UserInactivity } from './shared/services/user-inactivity/user-inactivity.service';
import { effects, initialState, reducers } from './store';
import { resetStoreState } from './store/meta-reducers/reset-store-state';
import { GraphQlStudentPathsHelperService } from './shared/services/graphql-helpers/student-paths/student-paths-queries.service';
import { GraphQLStudentDocLogsHelperService } from './shared/services/graphql-helpers/student-docLogs/student-docLogs-queries.service';
import { GraphQLCsvDownloadsService } from './shared/services/graphql-helpers/csv-downloads/csv-downloads.queries.service';
import { GraphQLGridViewHelperService } from './shared/services/graphql-helpers/gridviews/gridviews-queries.service';
import { GraphQLNvConfigsHelperService } from './shared/services/graphql-helpers/nv-configs/nv-configs.queries.service';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { GraphQLCollegeNowHelperService } from './shared/services/graphql-helpers/college-now/college-now-queries.services';
import { NetDashTileDataService } from './network/network-top-level/net-dash-tile-data/net-dash-tile-data.service';
import { NetworkMidLevelDataService } from './network/network-mid-level/network-mid-level-data/network-mid-level-data.service';
import { GoogleAnalyticsTrackerService } from 'projects/shared/services/google-analytics/google-analytics-tracker.service';
import { GraphQLNotesHelperService } from './shared/services/graphql-helpers/notes/notes-queries.services';
import { GraphQLEcfikCheckinsQueriesService } from './shared/services/graphql-helpers/ecfik/ecfik-checkins-queries.service';
import { GraphQLPdfReportsService } from './shared/services/graphql-helpers/pdf-reports/pdf-reports-queries.service';
import { AuthModule, AuthConfig } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { GraphQLGlobalFilterConfigsQueriesService } from './shared/services/graphql-helpers/global-filter-configs/global-filter-configs-queries.service';

// Optional because not every app.env.json block defines these yet; the guard
// below turns a missing value into a bootstrap error instead of a compile error.
interface Auth0PublicConfig {
  AUTH0_HOSTNAME?: string;
  AUTH0_CLIENT_ID?: string;
  AUTH0_AUDIENCE?: string;
}

const getAuth0Config = (): AuthConfig => {
  const { AUTH0_HOSTNAME, AUTH0_CLIENT_ID, AUTH0_AUDIENCE } = environment.PUBLIC_CONFIG as Auth0PublicConfig;
  // Fail at bootstrap rather than guessing: a build whose app.env.json block
  // lacks these values cannot mint valid RS256 access tokens, and a fallback
  // audience produces tokens the API rejects with errors that are much harder
  // to trace back here.
  if (!AUTH0_HOSTNAME || !AUTH0_CLIENT_ID || !AUTH0_AUDIENCE) {
    throw new Error('Auth0 is not configured for this environment: AUTH0_HOSTNAME, AUTH0_CLIENT_ID, and AUTH0_AUDIENCE are required in app.env.json');
  }

  return {
    domain: AUTH0_HOSTNAME,
    clientId: AUTH0_CLIENT_ID,
    authorizationParams: {
      audience: AUTH0_AUDIENCE,
      redirect_uri: `${window.location.origin}/callback`,
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    useRefreshTokensFallback: false,
    skipRedirectCallback: true,
  };
};

const initializeEventBus = EventBus => () => EventBus.initializeNgrxActionPipeline();
const handleAuthentication = Auth => () => Auth.handleAuthentication();

// tslint:disable-next-line
const metaReducers: MetaReducer<any>[] = [resetStoreState];

// tslint:disable-next-line:max-classes-per-file
@NgModule({
  imports: [
    // THIRD PARTY
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    AuthModule.forRoot(getAuth0Config()),
    HttpInterceptorModule.forRoot(),
    NgIdleModule.forRoot(),
    NvPusherSocketIdInterceptor.forRoot(),
    StoreModule.forRoot(
      { PORTAL_STORE: reducers },
      { initialState,
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        },
      }
    ),
    // StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot(effects),
    // PORTAL MODULES
    NotificationsModule,
    SpinnerModalModule,
    AppRoutingModule,
    NvToastModule, // needed for store effect dependencies
    ErrorModalModule, // needed for pusher failures
    CourseDiffsAndGapPlansContainerModule,
    OverlayModule,
  ],
  declarations: [AppComponent],
  providers: [
    { provide: APP_INITIALIZER, useFactory: initializeEventBus, deps: [EventBus], multi: true },
    { provide: APP_INITIALIZER, useFactory: handleAuthentication, deps: [Auth], multi: true },
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandlerService,
    },
    { provide: RollbarService, useFactory: rollbarFactory },
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: {
        disabled: true,
        animation: {
          enterDuration: 0,
          exitDuration: 0,
        },
      },
    },
    UserInactivity,
    // After Route migration these dependencies need to be cleaned up
    GridConfigService,
    GridService,
    ModalsService,
    SnackBarService,
    BackgroundJob,
    MatSnackBar,
    AssignSupportModalService,
    // TEMPORARY: These should be removed when AngularJS wizards are removed for redesign or migrated to Angular
    GradPlanningConfigService,
    CreditGapsConfigService,
    RegentsPrepConfigService,
    RegentsPlanningConfigService,
    DefaultSdcConfigService,
    SorterColumn,
    AgGridFilterService,
    BooleanYesNoFilter,
    Auth,
    UtilitiesService,
    DateHelpers,
    LocalStorageService,
    WindowRef,
    PortalConfig,
    GraphQLDataLoadsHelperService,
    GraphQLActivitiesHelperService,
    GraphQLSchoolAssessmentsHelperService,
    GraphQLStudentAssessmentsHelperService,
    GraphQLSchoolClusterUserHelperService,
    GraphQlShelterClusterUserHelperService,
    GraphQLSchoolUserHelperService,
    GraphQLPartnerHelperService,
    GraphQLClusterHelperService,
    ToggleService,
    StudentSet,
    GraphQlStudentPathsHelperService,
    GraphQLStudentDocLogsHelperService,
    GraphQLCsvDownloadsService,
    GraphQLPdfReportsService,
    GraphQLNvConfigsHelperService,
    GraphQLGridViewHelperService,
    GraphQLExperiencesHelperService,
    GraphQLNotesHelperService,
    GraphQLEcfikCheckinsQueriesService,
    GraphQLGlobalFilterConfigsQueriesService,
    DistrictHelpers,
    GraphQLCollegeNowHelperService,
    NetDashTileDataService,
    NetworkMidLevelDataService,
    GoogleAnalyticsTrackerService,
    UserAndRouteContextService,
  ],
  bootstrap: [AppComponent],
})
/* istanbul ignore next */
export class AppModule { }
